/**
 * postMessage contract with the embedded Aristotle iframe.
 *
 * Versioned envelope both ways: { source, v, type, payload }. The security
 * boundary is the ORIGIN check (we only accept messages whose event.origin is
 * the Aristotle web origin returned by the session mint, and only post with
 * that explicit targetOrigin) — the `source` field is a courtesy label.
 *
 *   host  -> iframe: host:context, host:code, host:visibility
 *   iframe -> host : aristotle:ready, aristotle:request-code, aristotle:close,
 *                    aristotle:resize, aristotle:error
 */

export const ARISTOTLE_MESSAGE_VERSION = 1;
export const HOST_MESSAGE_SOURCE = 'sm-lite-host';

export const HOST_MESSAGES = {
    CONTEXT: 'host:context',
    CODE: 'host:code',
    VISIBILITY: 'host:visibility',
};

export const ARISTOTLE_MESSAGES = {
    READY: 'aristotle:ready',
    REQUEST_CODE: 'aristotle:request-code',
    CLOSE: 'aristotle:close',
    RESIZE: 'aristotle:resize',
    ERROR: 'aristotle:error',
};

const KNOWN_ARISTOTLE_TYPES = Object.values(ARISTOTLE_MESSAGES);

export const buildHostMessage = (type, payload) => ({
    source: HOST_MESSAGE_SOURCE,
    v: ARISTOTLE_MESSAGE_VERSION,
    type,
    ...(payload !== undefined ? { payload } : {}),
});

/** Parse untrusted MessageEvent.data into a known Aristotle message, or null. */
export const parseAristotleMessage = (data) => {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
    if (!KNOWN_ARISTOTLE_TYPES.includes(data.type)) return null;
    return { type: data.type, payload: data.payload ?? null };
};
